<template>
  <div class="container">
    <div class="row"
         v-for="(item, index) in list"
         :key="index"
         @click="clickPart(item.id, item.bodyPartsName)">
      <div>{{item.bodyPartsName}}</div>
      <img src="@/assets/ic_go.png" />
    </div>
  </div>
</template>

<script>
import { bodyList } from '@/api/guidance'

export default {
  name: 'BodyList',
  props: {
    sex: {
      type: Number,
      default: 1
    },
    type: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      list: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      bodyList({
        sex: this.sex,
        type: this.type
      }).then(res => {
        if (res.success && res.code == 200) {
          this.list = res.result
        }
      })
    },
    clickPart(id, name) {
      this.$emit('clickPart', id, name)
    }
  }
}
</script>

<style scoped>
.container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  border-top: 1px solid #f2f2f2;
  background-color: whitesmoke;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 15px;
  background-color: white;
  border-bottom: 1px solid #f2f2f2;
}

.row div {
  flex: 1;
}

.row img {
  width: 6px;
  height: 10px;
}
</style>